// Modül 4 - Ünite 3, 4, 5, 6 İçerikleri
// Kritik Hatalar - İletişim Hataları, Hazırlık Hataları, Stres Hataları, Final

const cabinCrewContentsM4U3to6 = {
  // ==================== ÜNİTE 3: İLETİŞİM HATALARI ====================
  'CM-M4-U3-L1': {
    lesson_id: 'CM-M4-U3-L1',
    title: 'Negatif Beden Dili',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kaçınılması Gereken Beden Dili Hataları',
      paragraphs: [
        'Beden diliniz sözlerinizi desteklemeli, çelişmemeli. İşte sık yapılan hatalar:',
        'Göz temasından kaçınmak: Güvensizlik veya dürüst olmama izlenimi verir.',
        'Kolları kavuşturmak: Savunmacı, kapalı duruş. Açık olun.',
        'Ayak sallamak/tırnak yemek: Gerginlik gösterir. Sakin durun.',
        'Aşırı el hareketleri: Dikkat dağıtır. Kontrollü ve doğal olun.',
        'Somurtkan yüz ifadesi: İlgisizlik gösterir. Hafif gülümseme, dikkatli ifade.',
        'Sırtınızı yaslamak: Rahat ama tembel görünebilir. Hafif öne eğilin, ilgi gösterin.'
      ],
      keyPoints: [
        'Göz teması kurun',
        'Açık duruş sergileyin',
        'Gerginlik belirtilerini kontrol edin',
        'Hafif gülümseme, ilgili yüz ifadesi'
      ]
    }
  },

  'CM-M4-U3-L2': {
    lesson_id: 'CM-M4-U3-L2',
    title: 'Yanlış İletişim',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Sözel İletişim Hataları',
      paragraphs: [
        'Konuşmanız kadar konuşmadığınız şeyler de değerlendirilir.',
        'Negatif kelimeler: "Yapamam, bilmiyorum, zor" yerine "Öğrenirim, araştırırım, mücadele ederim".',
        'Eski işverenler hakkında şikayet: ASLA olumsuz konuşmayın. Profesyonellik esastır.',
        'Maaş ve tatil günleri sormak: İlk mülakatta sormayın. Önce değer katacağınızı gösterin.',
        'Aşırı uzun cevaplar: 2-3 dakikayı geçmeyin. Öz ve net olun.',
        '"Bilmiyorum" demek: Normal, ama "Öğrenmeye istekliyim" ile bitirin.'
      ],
      keyPoints: [
        'Pozitif dil kullanın',
        'Eski işvereni eleştirmeyin',
        'Maaş sorusunu erken sormayın',
        'Kısa, öz cevaplar verin'
      ]
    }
  },

  'CM-M4-U3-L3': {
    lesson_id: 'CM-M4-U3-L3',
    title: 'Senaryo: Kötü İzlenimler',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Mülakatçı soruyor: "Önceki işinizden neden ayrıldınız?"',
      question: 'Gerçekte patronunuzla anlaşamadınız. Nasıl cevap verirsiniz?',
      options: [
        { id: 'A', text: 'Patronum çok zordu, sürekli eleştirirdi.', isCorrect: false },
        { id: 'B', text: 'Farklı bir sektörde kendimi geliştirmek ve havacılık tutkumu takip etmek istedim.', isCorrect: true },
        { id: 'C', text: 'Maaş yetersizdi, daha iyi kazanmak istiyorum.', isCorrect: false },
        { id: 'D', text: 'Çalışma saatleri çok ağırdı.', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Pozitif, gelecek odaklı, eski işverene saygılı. Profesyonel cevap.',
        wrong: 'Bu cevap negatif veya şikayetçi. Eski işveren hakkında olumsuz konuşmak büyük hata.'
      },
      explanation: 'Altın kural: Eski işveren/iş hakkında ASLA negatif konuşmayın. Her zaman pozitif ve gelecek odaklı olun.'
    }
  },

  'CM-M4-U3-L4': {
    lesson_id: 'CM-M4-U3-L4',
    title: '🎮 Hata Bul Quiz',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Göz temasından kaçınmak güvensizlik gösterir.', isTrue: true, explanation: 'Doğru! Göz teması güven ve samimiyet işareti.' },
        { statement: 'Mülakatta maaş sormak ilgiyi gösterir.', isTrue: false, explanation: 'Yanlış! İlk mülakatta maaş sormak olumsuz izlenim bırakır.' },
        { statement: 'Eski patronunuzu eleştirmek dürüstlüktür.', isTrue: false, explanation: 'Kesinlikle yanlış! Bu profesyonellik eksikliği gösterir.' },
        { statement: 'Kısa ve öz cevaplar tercih edilir.', isTrue: true, explanation: 'Doğru! 2-3 dakikayı geçmeyen, net cevaplar idealdir.' },
        { statement: 'Kolları kavuşturmak rahatlık gösterir.', isTrue: false, explanation: 'Yanlış! Bu savunmacı ve kapalı bir duruştur.' }
      ]
    }
  },

  // ==================== ÜNİTE 4: HAZIRLIK HATALARI ====================
  'CM-M4-U4-L1': {
    lesson_id: 'CM-M4-U4-L1',
    title: 'Araştırma Eksikliği',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Havayolu ve Sektör Araştırması',
      paragraphs: [
        'Hazırlıksız mülakat = Başarısız mülakat. Araştırma yapmamanın bedeli ağırdır.',
        'Havayolu hakkında: Tarihçe, filo, destinasyonlar, değerler, son haberler.',
        'Sektör hakkında: Rakipler, trendler, zorluklar, fırsatlar.',
        'Pozisyon hakkında: Görev tanımı, gereksinimler, kariyer yolu.',
        'Sık hata: "Neden bu havayolu?" sorusuna genel cevap vermek. Spesifik olun!',
        'Örnek: "THY\'nin 350+ destinasyonu ve Türk misafirperverliği beni çekiyor" gibi somut detaylar verin.'
      ],
      keyPoints: [
        'Havayolunu detaylı araştırın',
        'Sektör trendlerini bilin',
        'Spesifik ve somut bilgiler verin',
        'Son haberleri takip edin'
      ]
    }
  },

  'CM-M4-U4-L2': {
    lesson_id: 'CM-M4-U4-L2',
    title: 'Pratik Eksikliği',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakat Pratiği Yapmanın Önemi',
      paragraphs: [
        'En iyi cevapları bilmek yetmez, onları SÖYLEMEK de pratiği gerektirir.',
        'Ayna karşısında pratik: Beden dilinizi, yüz ifadenizi görün.',
        'Arkadaşla pratik: Gerçek mülakat ortamı simülasyonu yapın.',
        'Video kaydı: Kendinizi izleyin, gelişim alanlarını tespit edin.',
        'Sık sorular: "Kendinizi tanıtın", "Neden kabin memuru", "Zayıf yönünüz" gibi klasikleri ezberleyin değil, içselleştirin.',
        'Zamanlama: Cevaplarınızı 2-3 dakikayla sınırlayın. Pratik yaparak bunu ölçün.'
      ],
      keyPoints: [
        'Bilmek yetmez, pratik şart',
        'Ayna ve video ile çalışın',
        'Arkadaşla simülasyon yapın',
        'Zamanlamayı ölçün'
      ]
    }
  },

  'CM-M4-U4-L3': {
    lesson_id: 'CM-M4-U4-L3',
    title: 'Lojistik Hatalar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakat Günü Lojistik Hataları',
      paragraphs: [
        'Mülakat performansınız evden çıkmadan başlar. Lojistik hatalar stresi artırır.',
        'Geç kalmak: EN BÜYÜK hata. Minimum 30 dakika erken orada olun.',
        'Yanlış kıyafet: Önceden hazırlayın, ütüleyin, deneyin.',
        'Belgeleri unutmak: CV, kimlik, fotoğraf, diploma kopyaları... Kontrol listesi yapın.',
        'Ulaşım: Yol süresini hesaplayın, alternatif rota belirleyin.',
        'Sağlık: İyi uyuyun, kahvaltı yapın, su için. Yorgun veya aç gitmeyin.'
      ],
      keyPoints: [
        'Minimum 30 dk erken olun',
        'Kıyafet önceden hazır',
        'Belgeler kontrol listesiyle',
        'İyi uyku ve beslenme'
      ]
    }
  },

  'CM-M4-U4-L4': {
    lesson_id: 'CM-M4-U4-L4',
    title: '⚡ Hata Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Mülakat öncesi en önemli hazırlık?', options: ['Uyumak', 'Havayolu araştırması', 'Alışveriş', 'Tatil planı'], correct: 1 },
        { q: 'Mülakatta geç kalmak nasıl algılanır?', options: ['Normal', 'Çok ciddi hata', 'Şıklık', 'Önemsiz'], correct: 1 },
        { q: 'Pratik yapmanın en iyi yolu?', options: ['Sadece okumak', 'Video kaydı + arkadaşla simülasyon', 'Düşünmek', 'Meditasyon'], correct: 1 },
        { q: '"Neden bu havayolu?" sorusuna en iyi cevap?', options: ['Maaş iyi', 'Genel övgü', 'Spesifik şirket detayları', 'Bilmiyorum'], correct: 2 },
        { q: 'Mülakat sabahı yapılmaması gereken?', options: ['Kahvaltı', 'Belge kontrolü', 'Gece geç yatmak', 'Erken kalkmak'], correct: 2 }
      ]
    }
  },

  // ==================== ÜNİTE 5: STRES YÖNETİMİ HATALARI ====================
  'CM-M4-U5-L1': {
    lesson_id: 'CM-M4-U5-L1',
    title: 'Aşırı Stres Yönetimi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakat Stresini Yönetmek',
      paragraphs: [
        'Stres normaldir ama kontrolsüz stres performansı düşürür.',
        'Fiziksel belirtiler: Titreme, terleme, kızarma, kalp çarpıntısı.',
        'Nefes teknikleri: 4-7-8 tekniği (4 sn nefes al, 7 sn tut, 8 sn ver).',
        'Zihinsel hazırlık: Başarılı mülakat görselleştirmesi, pozitif self-talk.',
        'Stresi kabul edin: "Heyecanlıyım çünkü bu benim için önemli" - stresi pozitife çevirin.',
        'Pratikle azaltın: Ne kadar çok pratik, o kadar az stres. Bilinmeyen korkutur.'
      ],
      keyPoints: [
        'Stres normal, kontrol edilebilir',
        'Nefes teknikleri uygulayın',
        'Pozitif görselleştirme yapın',
        'Pratik stresi azaltır'
      ]
    }
  },

  'CM-M4-U5-L2': {
    lesson_id: 'CM-M4-U5-L2',
    title: 'Kararsızlık ve Aşırı Düşünme',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Overthinking: Aşırı Analiz Felci',
      paragraphs: [
        'Bazı adaylar her cevabı aşırı analiz eder ve doğallığını kaybeder.',
        'Belirtiler: Çok uzun düşünme süreleri, cevapları sürekli değiştirme, "acaba" döngüsü.',
        'Risk: Mülakat boyunca robotik, samimiyetsiz görünmek.',
        'Çözüm: İlk içgüdünüze güvenin. Genellikle doğrudur.',
        'Hata yaparsanız: Düzeltin ve devam edin. Aşırı özür dilemeyin.',
        'Spontanlık: Mülakatçılar mükemmel değil, GERÇEK insanlar arar.'
      ],
      keyPoints: [
        'Aşırı düşünme doğallığı öldürür',
        'İlk içgüdünüze güvenin',
        'Hata yaparsanız düzeltip devam edin',
        'Gerçek ve samimi olun'
      ]
    }
  },

  'CM-M4-U5-L3': {
    lesson_id: 'CM-M4-U5-L3',
    title: 'Senaryo: Panik Anı',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Mülakatta beklemediğiniz bir soru geldi ve zihniniz bomboş kaldı:',
      question: 'Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Panikle "Bilmiyorum" derim ve sessizce beklerim.', isCorrect: false },
        { id: 'B', text: '"Bu ilginç bir soru, bir saniye düşünmeme izin verin" derim, derin nefes alır ve cevaplarım.', isCorrect: true },
        { id: 'C', text: 'Konuyu değiştirmeye çalışırım.', isCorrect: false },
        { id: 'D', text: 'Ağlamaya başlarım, çok stresli.', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Düşünme süresi istemek normaldir. Sakinliğinizi koruyup profesyonel kaldınız.',
        wrong: 'Bu tepki ya panik ya da kaçınma gösterir. Sakin kalıp düşünme süresi istemek en iyi strateji.'
      },
      explanation: 'Zor sorular beklenir. Önemli olan NASIL tepki verdiğiniz. Sakinlik, düşünme süresi isteme ve toparlanma yeteneği değerlidir.'
    }
  },

  'CM-M4-U5-L4': {
    lesson_id: 'CM-M4-U5-L4',
    title: '🎮 Stres Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { left: '4-7-8 tekniği', right: 'Nefes egzersizi' },
        { left: 'Görselleştirme', right: 'Başarılı mülakat hayal etme' },
        { left: 'Self-talk', right: 'Kendine pozitif konuşma' },
        { left: 'Overthinking', right: 'Aşırı analiz yapma' },
        { left: 'Spontanlık', right: 'Doğal, anlık tepkiler' },
        { left: 'Pratik', right: 'Stresi azaltan en iyi yöntem' }
      ]
    }
  },

  // ==================== ÜNİTE 6: FİNAL ====================
  'CM-M4-U6-L1': {
    lesson_id: 'CM-M4-U6-L1',
    title: '🎓 Modül 4 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'Mülakatta eski işveren hakkında ne söylenmeli?', options: ['Negatif yorumlar', 'Hiçbir şey', 'Sadece pozitif veya nötr', 'Şikayetler'], correct: 2 },
        { q: 'Göz temasından kaçınmak ne izlenimi verir?', options: ['Saygı', 'Güvensizlik', 'Dikkat', 'Rahatlık'], correct: 1 },
        { q: 'Mülakat için ne kadar erken gidilmeli?', options: ['Tam saatinde', 'Minimum 30 dk erken', '5 dk erken', '2 saat erken'], correct: 1 },
        { q: 'Stres yönetimi için en iyi teknik?', options: ['Kaçınmak', 'Nefes teknikleri', 'Reddetmek', 'Görmezden gelmek'], correct: 1 },
        { q: '"Neden bu havayolu?" için en iyi cevap türü?', options: ['Genel övgü', 'Maaş odaklı', 'Spesifik şirket detayları', 'Bilmiyorum'], correct: 2 },
        { q: 'Aşırı düşünmenin (overthinking) riski?', options: ['Mükemmel cevaplar', 'Doğallık kaybı', 'Daha iyi performans', 'Hiçbiri'], correct: 1 },
        { q: 'Beklenmedik soruda ne yapmalı?', options: ['Paniklemek', 'Konuyu değiştirmek', 'Düşünme süresi istemek', 'Ağlamak'], correct: 2 },
        { q: 'Kolları kavuşturmak ne ifade eder?', options: ['Rahatlık', 'Savunmacılık', 'İlgi', 'Coşku'], correct: 1 },
        { q: 'Mülakat pratiği için en iyi yöntem?', options: ['Sadece okumak', 'Sadece düşünmek', 'Video kaydı + simülasyon', 'Hiçbiri'], correct: 2 },
        { q: 'Lojistik hazırlık neyi içerir?', options: ['Sadece kıyafet', 'Belgeler, ulaşım, kıyafet, sağlık', 'Sadece CV', 'Hiçbiri'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM4U3to6;
